export interface User {
  id: string;
  legacyId: number;
  firstName: string;
  lastName: string;
  profileImageUrl: string;
  email: string;
  isEmailVerified: boolean;
  isPhoneVerified: boolean;
  isVerified: boolean;
  lang: string;
  birthDate: number | null;
  birthPlace: string | null;
  gender: string | null;
  phone: string | null;
  paymentAccounts: {
    userId: string;
    paymentPlatform: string;
  }[];
  isSuperAdmin?: boolean;
}

export const USER_PERMISSIONS = {
  DOWNLOAD_BOOKING_PDF: 'DOWNLOAD_BOOKING_PDF',
  EXPORT_BOOKINGS: 'EXPORT_BOOKINGS',
  READ_PREREGISTRATIONS: 'READ_PREREGISTRATIONS',
  EXPORT_PREREGISTRATIONS: 'EXPORT_PREREGISTRATIONS',
  EXPORT_SALES_RECAP: 'EXPORT_SALES_RECAP',
  READ_ANALYTICS: 'READ_ANALYTICS',
  READ_BOOKING_DETAILS: 'READ_BOOKING_DETAILS',
  READ_CHANNELS: 'READ_CHANNELS',
  READ_COMPANIES: 'READ_COMPANIES',
  READ_COMPANY_OFFERS: 'READ_COMPANY_OFFERS',
  READ_COMPANY_SETTINGS: 'READ_COMPANY_SETTINGS',
  READ_CUSTOMERS: 'READ_CUSTOMERS',
  READ_DRAFT_EVENTS: 'READ_DRAFT_EVENTS',
  READ_EVENTS_REVENUE: 'READ_EVENTS_REVENUE',
  READ_EVENTS_SOLD_ITEMS: 'READ_EVENTS_SOLD_ITEMS',
  READ_EVENTS: 'READ_EVENTS',
  READ_INSIGHTS: 'READ_INSIGHTS',
  READ_MARKETING: 'READ_MARKETING',
  READ_OFFERS: 'READ_OFFERS',
  READ_OFFERS_QUANTITY: 'READ_OFFERS_QUANTITY',
  READ_PAST_EVENTS: 'READ_PAST_EVENTS',
  READ_STATS: 'READ_STATS',
  READ_TEAMS: 'READ_TEAMS',
  REFUND_BOOKING: 'REFUND_BOOKING',
  RESEND_BOOKING_EMAIL: 'RESEND_BOOKING_EMAIL',
  WRITE_BOX_OFFICE: 'WRITE_BOX_OFFICE',
  WRITE_CLUBS: 'WRITE_CLUBS',
  WRITE_COMPANY_OFFERS: 'WRITE_COMPANY_OFFERS',
  WRITE_EVENTS: 'WRITE_EVENTS',
  WRITE_IMPORT_CSV: 'WRITE_IMPORT_CSV',
  WRITE_INVITATIONS: 'WRITE_INVITATIONS',
  WRITE_OFFERS: 'WRITE_OFFERS',
  WRITE_OFFLINE_SALES: 'WRITE_OFFLINE_SALES',
  WRITE_COMPANY_SETTINGS: 'WRITE_COMPANY_SETTINGS',
  READ_BOOKINGS: 'READ_BOOKINGS',
  RECEIVE_EMAIL_RECAP: 'RECEIVE_EMAIL_RECAP',
  MANAGE_USERS: 'MANAGE_USERS',
  SHARE_EVENT_REPORT: 'SHARE_EVENT_REPORT',
};

export type UserPermission = (typeof USER_PERMISSIONS)[keyof typeof USER_PERMISSIONS];
